module.exports = __webpack_public_path__ + "i18n/ko.7a87e1c6bc1863e9963603b2c33de858.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 851
// module chunks = 60